import { useMemo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import useCellCopyAction from "../useCellCopyAction";
import IntentProjectResourcesTableGroupCell from "../GroupCell";
import { IntentResourceRow } from "../tableDataSelectors";

const IntentProjectResourcesTableTypeCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<IntentResourceRow>) => {
  const copyAction = useCellCopyAction({
    text: resource.resourceType,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IntentProjectResourcesTableGroupCell
      {...cellProps}
      actions={actions}
      isGroup={resource.isGroup}
      groupId={resource.resourceID}
      intentProjectId={resource.intentProjectID}
    >
      <TableCellText>{resource.resourceType}</TableCellText>
    </IntentProjectResourcesTableGroupCell>
  );
};

export default IntentProjectResourcesTableTypeCell;
